import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetAutomations = (params) => api.get(apiUrl.shoutouts, { params });
export const UpdateAutomations = (data) =>
  api.post(apiUrl.salon_shoutouts, data);
